import {Integer, ThemeColorTextPath} from 'platform/foundation';

import {useMemo} from 'react';

import {isNotNil, sort} from 'ramda';

import {suffixTestId, TestIdProps} from 'shared/web';

import {useFeatureCompare} from '../../../utils/useFeatureCompare';
import {FeatureListColumn} from './FeatureListColumn';
import {FeatureListRow} from './FeatureListRow';

interface ListProps extends TestIdProps {
  spacing: Integer;
  textColor: ThemeColorTextPath;
  values?: string[] | null;
  compareWith?: string[] | null;
  isRow?: boolean;
  firstWhite?: boolean;
  isSortable?: boolean;
  isMyVehicle?: boolean;
  isMyAd?: boolean;
  isBold?: boolean;
}

export function FeatureList(props: ListProps) {
  const featureCompare = useFeatureCompare();

  const vehicleFeatures = useMemo(
    () =>
      props.isSortable && isNotNil(props.values)
        ? sort(featureCompare, props.values)
        : props.values,
    [props.values, props.isSortable, featureCompare]
  );

  return props.isRow ? (
    <FeatureListRow
      values={vehicleFeatures}
      spacing={props.spacing}
      textColor={props.textColor}
      data-testid={suffixTestId('featureListRow', props)}
    />
  ) : (
    <FeatureListColumn
      values={vehicleFeatures}
      compareWith={props.compareWith}
      isFirstWhite={props.firstWhite}
      isBold={props.isBold}
      spacing={props.spacing}
      textColor={props.textColor}
      isMyVehicle={props.isMyVehicle}
      isMyAd={props.isMyAd}
      data-testid={suffixTestId('featureListColumn', props)}
    />
  );
}
